import * as React from 'react';
import { CacheFactory } from '@citrite/workspace-ui-platform';

export interface Context {
	cacheFactory: CacheFactory;
}
export const CacheContext = React.createContext<Context>(null);
